<template>
  <div>
    <filtro @atualizar-grid="atualizaFiltros"></filtro>
    <v-data-table
      class="elevation-5 mb-4 pa-0"
      no-data-text="Não há registros"
      rows-per-page-text="Linhas por página"
      :headers="headers"
      :items="protocolos"
      :loading="isLoading"
      :pagination.sync="pagination"
      :total-items="totalProtocolos"
      :rows-per-page-items="pageOptions"
      @update:pagination="atualizaPaginacao"
    >
      <template v-slot:items="props">
        <td>{{ props.item.numeroProtocolo }}</td>
        <td>{{ props.item.dataAtendimento }}</td>
        <td>{{ props.item.status }}</td>
        <td>{{ props.item.tipoSolicitacao }}</td>
        <td>{{ props.item.numeroGuia }}</td>
        <td>
          <v-btn
            flat
            small
            class="green--text"
            @click="detalhar(props.item.numeroProtocolo)"
            >DETALHAR</v-btn
          >
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

import { buscaProtocoloGrid } from "./service";

import Filtro from "./filtro";

const beneficiarioStore = createNamespacedHelpers("beneficiario");
const portalStore = createNamespacedHelpers("portal");

export default {
  name: "ProtocoloGrid",
  components: {
    Filtro
  },
  data() {
    return {
      filtro: {},
      protocolos: [],
      headers: [
        { text: "Nº Protocolo", value: "numeroProtocolo", sortable: false },
        { text: "Data abertura", value: "dataAtendimento", sortable: false },
        { text: "Status do protocolo", value: "status", sortable: false },
        {
          text: "Tipo de solicitação",
          value: "tipoSolicitacao",
          sortable: false
        },
        { text: "Guia", value: "numeroGuia", sortable: false },
        { text: "Ação", value: "acao", sortable: false }
      ],
      isLoading: false,
      pageOptions: [5, 10, 25, 35],
      pagination: {},
      totalProtocolos: 0
    };
  },
  computed: {
    ...beneficiarioStore.mapState(["dadosBeneficiario"]),
    ...portalStore.mapGetters(["getFiltro", "getPaginacao"]),
    codigoBeneficiario() {
      return this.dadosBeneficiario.id;
    },
    cpf() {
      return this.dadosBeneficiario.cpf;
    }
  },
  watch: {
    codigoBeneficiario: {
      async handler() {
        await this.gridProtocolos();
      }
    }
  },
  created() {
    this.pagination = this.getPaginacao;
  },
  methods: {
    ...portalStore.mapMutations([
      "setErrorToast",
      "setFiltro",
      "setPaginacao",
      "setToast"
    ]),
    atualizaFiltros(filtro) {
      this.setFiltro(filtro);

      this.gridProtocolos();
    },
    atualizaPaginacao() {
      this.setPaginacao(this.pagination);

      this.gridProtocolos();
    },
    detalhar(numeroProtocolo) {
      this.$emit("detalhar", numeroProtocolo);
    },
    gridProtocolos() {
      this.isLoading = true;

      const { page, rowsPerPage } = this.getPaginacao;
      const {
        numeroProtocolo,
        numeroGuia,
        dataInicial,
        dataFinal,
        tipoSolicitacao,
        statusProtocolo
      } = this.getFiltro;

      const payload = {
        codigoBeneficiario: this.codigoBeneficiario,
        cpf: this.cpf,
        numeroProtocolo,
        numeroGuia,
        dataInicial,
        dataFinal,
        tipoSolicitacao,
        statusProtocolo,
        page: page - 1,
        size: rowsPerPage
      };

      buscaProtocoloGrid(payload)
        .then(({ data }) => data)
        .then(({ content, totalElements }) => {
          this.protocolos = content;
          this.totalProtocolos = totalElements;
        })
        .catch(({ response }) => {
          if (response?.data?.error) {
            const errorMessage = response?.data?.message;

            this.setToast(errorMessage);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
